import React from 'react';

const Projects = () => {
  return (
    <section className="projects-section" id="projects">
      <div class="wrapper">
        <div class="item">
          <a
            href="https://michal-codes.github.io/pawpaw/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="resources/img/pawpaw.png" alt="PawPaw Website" />
            <h3>PawPaw (Polish)</h3>
            <p>
              Layout for fake company. Design in a browser. Create responsive
              portable layout for customer.
            </p>
          </a>
        </div>
        <div class="item">
          <a
            href="https://michal-codes.github.io/JS30/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="resources/img/JS30.png" alt="my JavaScript30" />
            <h3>JavaScript30</h3>
            <p>
              Practice of JS30 (Wes Bos). Without any frameworks only ES6 syntax
              vanilla JavaScript.
            </p>
          </a>
        </div>
        <div class="item">
          <a
            href="https://michal-codes.github.io/react-hooks-todo/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="resources/img/todo.png"
              alt="React Todo with fetching data"
            />
            <h3>Todo</h3>
            <p>
              React Todo App (hooks). Using json-server and axios library to
              fetch data from mock API
            </p>
          </a>
        </div>
        <div class="item">
          <a
            href="https://michal-codes.github.io/rgb-color-game/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="resources/img/rgb.png" alt="RGB Color Game" />
            <h3>RGB Color Game</h3>
            <p>
              JS rgb color guessing game made with logic written in Vanilla
              JavaScript
            </p>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Projects;
